var map = {
	"./BasicSelector": 21,
	"./BasicSelector.js": 21,
	"./InventoryReport": 46,
	"./InventoryReport.js": 46,
	"./PartDashboardSearch": 47,
	"./PartDashboardSearch.js": 47,
	"./SelectOrLegacy": 48,
	"./SelectOrLegacy.js": 48,
	"./utils/utils": 49,
	"./utils/utils.js": 49
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54;